import { Component, ViewChild, OnInit } from '@angular/core';
import { LoadingBarService } from '@ngx-loading-bar/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Globals } from 'app/_globals';
import { FormGroup, FormBuilder, FormControl, Validators } from '@angular/forms';
import { NotificationService } from 'app/_services/notification.service';
import { environment } from '../../environments/environment';
import { DynamicFormComponent } from '../_dynamic_form/containers/dynamic_form/dynamic-form.component';
import { TreeNode } from 'primeng/api';
import { ProductsService } from '../_services/products.service';
import { CategoryService } from '../_services/category.service';
import { KioskCategoryService } from '../_services/kiosk-category.service';
import { FoodToGoService } from '../_services/food-to-go.service';
import { ObjectFilterPipe } from '../_pipes/object-filter.pipe';
import { CookieService } from 'ngx-cookie-service';
import { CurrencyPipe } from '@angular/common';

import { LinkRendererComponent } from '../components/ag-grid/link-renderer.component';
import { ProductDetailsLinkComponent } from '../components/ag-grid/product-details-link.component';

// Models
import { Product } from '../_models/product.model';
import { FoodToGoCategoriesComponent } from 'app/food-to-go-categories/food-to-go-categories.component';

@Component({
  selector: 'app-products',
  templateUrl: './products-v2.component.html',
  styleUrls: ['./products-v2.component.css'],
  providers: [CurrencyPipe, LinkRendererComponent, ProductDetailsLinkComponent],
})
export class ProductsV2Component implements OnInit {
  @ViewChild(DynamicFormComponent) filterForm: DynamicFormComponent;

  /****** AG-GRID ******/

  gridOptions;

  defaultColDef = {
    resizable: true,
    sortable: true,
    filter: true,
  };

  columnDefs = [];

  displayEditDialog = false;
  dialogProductId = null;

  selectedRows: any[] = [];

  /****** EOF AG-GRID ******/

  products: any[] = [];
  selectedProduct: any;

  storeId: any;
  cookieStore: any;
  currency = '';

  sidebarVisible = false;
  createProductModal = false;
  createProductForm: FormGroup;
  errMsgs: any[] = [];
  bulkCategoryChangeToggle = false;

  rowSelection = 'multiple';

  displayCategories: TreeNode[] = [];
  categories: any[] = [];
  selectedCategory = {
    label: 'No Category Selected',
    id: null,
    name: null,
    data: { id: null },
  };

  displayKioskCategories: TreeNode[] = [];
  kioskCategories: any[] = [];
  selectedKioskCategory = {
    label: 'No Kiosk Category Selected',
    id: null,
    data: { id: null },
  };

  displayFoodToGoCategories: TreeNode[] = [];
  foodToGoCategories: any[] = [];
  selectedFoodToGoCategory = {
    label: 'No Food To Go Category Selected',
    id: null,
    data: { id: null },
  };

  private gridApi;
  private gridColumnApi;

  constructor(
    public loader: LoadingBarService,
    public activatedRoute: ActivatedRoute,
    public router: Router,
    public globals: Globals,
    public fb: FormBuilder,
    public notificationService: NotificationService,
    public _productsService: ProductsService,
    public _categoryService: CategoryService,
    public _kioskCategoryService: KioskCategoryService,
    public _foodToGoService: FoodToGoService,
    public objectFilter: ObjectFilterPipe,
    public cookieService: CookieService,
    private currencyPipe: CurrencyPipe
  ) {
    this.createProductForm = fb.group({
      name: new FormControl('', [Validators.required]),
      displayName: new FormControl('', [Validators.required]),
      price: new FormControl('', [Validators.required]),
      description: new FormControl(''),
      ean: new FormControl(''),
      productCode: new FormControl(''),
      sortOrder: new FormControl(''),
      allergensApiProductId: new FormControl(''),
      itemCategoryId: new FormControl(''),
      itemCategoryKioskId: new FormControl(''),
      itemCategoryFoodToGoId: new FormControl(''),
      itemFoodToGoCategory: new FormControl(''),
    });

    // Handle Store Cookies
    const hasCurrentStore = cookieService.check('currentStore');
    if (hasCurrentStore) {
      this.cookieStore = JSON.parse(cookieService.get('currentStore'));
      this.storeId = this.cookieStore.id;
      this.currency = this.cookieStore.currency;
    } else {
      this.router.navigate(['/' + this.globals.user.routeRole + '/select-store']);
    }
  }

  ngOnInit() {
    this.getAllProducts();
    this.getAllCategories();
    this.getAllKioskCategories();
    this.getAllFoodToGoCategories();

    this.gridOptions = {
      context: {
        componentParent: this,
      },
    };

    this.columnDefs = [
      {
        headerName: 'Actions',
        filter: false,
        draggable: false,
        checkboxSelection: true,
        cellRendererFramework: ProductDetailsLinkComponent,
        cellRendererParams: {},
      },
      { headerName: 'EAN', field: 'ean' },
      // { headerName: 'Sort Name', field: 'name' },
      {
        headerName: 'Display Name',
        getQuickFilterText: function (params: any) {
          let name = params.data.displayName;
          if (
            params.data.warehouseInformation &&
            params.data.warehouseInformation.brandbankinformation
          ) {
            name = params.data.warehouseInformation.brandbankinformation.description;
          }
          return name;
        },
        cellRenderer: function (params: any) {
          let name = params.data.displayName;
          if (
            params.data.warehouseInformation &&
            params.data.warehouseInformation.brandbankinformation
          ) {
            name = params.data.warehouseInformation.brandbankinformation.description;
          }
          return name;
        },
      },
      {
        headerName: 'Price',
        field: 'price',
        valueFormatter: this.currencyFormatter(this.currency),
        getQuickFilterText: function (params) {
          return params.value;
        },
      },
      {
        headerName: 'Category',
        getQuickFilterText: function (params: any) {
          let name = '';
          if (params.data.itemCategory && params.data.foodToGoItemCategory) {
            name = params.data.itemCategory.name + ', ' + params.data.foodToGoItemCategory.name;
          } else if (!params.data.itemCategory && params.data.foodToGoItemCategory) {
            name = params.data.foodToGoItemCategory.name;
          } else if (params.data.itemCategory && !params.data.foodToGoItemCategory) {
            name = params.data.itemCategory.name;
          }
          return name;
        },
        cellRenderer: function (params: any) {
          let name = '';
          if (params.data.itemCategory && params.data.foodToGoItemCategory) {
            name = params.data.itemCategory.name + ', ' + params.data.foodToGoItemCategory.name;
          } else if (!params.data.itemCategory && params.data.foodToGoItemCategory) {
            name = params.data.foodToGoItemCategory.name;
          } else if (params.data.itemCategory && !params.data.foodToGoItemCategory) {
            name = params.data.itemCategory.name;
          }
          return name;
        },
      },
      { headerName: 'Age Restriction', field: 'ageRestriction' },
      {
        headerName: 'Stock',
        filter: true,
        cellRenderer: this.stockCellRenderer,
        valueGetter: function (params: any) {
          if (params.data.alwaysInStock) {
            return `Always In Stock`;
          }

          if (params.data.stock > 0) {
            return `In Stock ${params.data.stock}`;
          }
          if (params.data.inStock) {
            return 'In Stock';
          } else {
            return 'Out Of Stock';
          }
        },
        filterValueGetter: function (params: any) {
          if (params.data.alwaysInStock) {
            return `Always In Stock`;
          }

          if (params.data.stock > 0) {
            return `In Stock ${params.data.stock}`;
          }

          if (params.data.inStock) {
            return 'In Stock';
          } else {
            return 'Out Of Stock';
          }
        },
      },
      {
        headerName: 'Status',
        filter: true,
        cellRenderer: this.statusCellRenderer,
        valueGetter: function (params: any) {
          if (params.data.enabled) {
            return 'Enabled';
          }
          if (!params.data.enabled) {
            return 'Disabled';
          }
          return params.value;
        },
        filterValueGetter: function (params: any) {
          if (params.data.enabled) {
            return 'Enabled';
          }
          if (!params.data.enabled) {
            return 'Disabled';
          }
          return params.value;
        },
      },
    ];
  }

  onSelectionChanged(e) {
    this.selectedRows = this.gridApi.getSelectedRows();
  }

  setEnabled(enabled) {
    let count = this.selectedRows.length;
    this.selectedRows.forEach((item, index) => {
      this._productsService.setEnabled(item.id, enabled).subscribe((data: any) => {
        count--;
        if (count < 1) {
          this.gridApi.deselectAll();
          this.getAllProducts();
          this.notificationService.notify(
            'success',
            'Products Updated',
            'Selected products have been updated',
            'top',
            'right'
          );
        }
      });
    });
  }

  deselectRows() {
    this.gridApi.deselectAll();
  }

  /****** AG-GRID ******/

  statusCellRenderer(params) {
    let html = '';
    if (params.data.enabled) {
      html += '<span class="badge badge-pill badge-success mr-2">Enabled</span>';
    }
    if (!params.data.enabled) {
      html += '<span class="badge badge-pill badge-warning mr-2">Disabled</span>';
    }
    if (params.data.managed) {
      html += '<span class="badge badge-pill badge-secondary mr-2">Managed</span>';
    }
    if (params.data.discontinued) {
      html += '<span class="badge badge-pill badge-danger mr-2">Discontinued</span>';
    }
    return html;
  }

  stockCellRenderer(params) {
    let html = '';
    let stock = '';

    if (params.data.stock != null) {
      stock += `(${params.data.stock})`;
    }

    if (params.data.alwaysInStock) {
      html += `<span class="badge badge-pill badge-success mr-2">Always In Stock</span>`;
    } else {
      if (params.data.inStock) {
        html += `<span class="badge badge-pill badge-success mr-2">In Stock ${stock}</span>`;
      }
      if (!params.data.inStock) {
        html += `<span class="badge badge-pill badge-warning mr-2">Out of Stock ${stock}</span>`;
      }
    }

    return html;
  }

  currencyFormatter(currency) {
    return (params) => {
      const currencyString = this.currencyPipe.transform(params.value, currency);
      return currencyString;
    };
  }

  sizeToFit() {
    this.gridApi.sizeColumnsToFit();
  }

  autoSizeAll(skipHeader) {
    const allColumnIds = [];
    this.gridColumnApi.getAllColumns().forEach(function (column) {
      allColumnIds.push(column.colId);
    });
    this.gridColumnApi.autoSizeColumns(allColumnIds, skipHeader);
  }

  onGridReady(params) {
    // console.log('onGridReady', params);
    this.gridApi = params.api;
    this.gridColumnApi = params.columnApi;
  }

  firstDataRendered(e) {
    // console.log('firstDataRendered');

    this.autoSizeAll(false);
    this.sizeToFit();
  }

  quickFilterSearch(data) {
    if (data) {
      // console.log('quickFilterSearch', data);
      this.gridApi.setQuickFilter(data);
    } else {
      this.gridApi.setQuickFilter('');
    }
  }

  bulkCategoryChange() {
    this.bulkCategoryChangeToggle = !this.bulkCategoryChangeToggle;
  }

  saveBulkCategoryChange(selectedRows) {
    console.log('save all', selectedRows);
    selectedRows.forEach((selectedProduct, index) => {
      const body: Product = {
        id: selectedProduct.id,
        description: selectedProduct.description,
        discontinued: selectedProduct.discontinued,
        displayName: selectedProduct.displayName,
        ean: selectedProduct.ean,
        categoryId: selectedProduct.categoryId,
        categoryKioskId: selectedProduct.categoryKioskId,
        foodToGoCategoryId: selectedProduct.categoryFoodToGoId,
        managed: selectedProduct.managed,
        name: selectedProduct.name,
        price: selectedProduct.price,
        productCode: selectedProduct.productCode,
        sortOrder: selectedProduct.sortOrder,
        allergensApiProductId: selectedProduct.allergensApiProductId,
        enabled: selectedProduct.enabled,
        ageRestriction: selectedProduct.ageRestriction,
        ingredients: selectedProduct.ingredients,
        nutrition: selectedProduct.nutrition,
      };

      this._productsService.editProduct(body).subscribe((data: any) => {
        this.onUpdateProductList(true);
        this.notificationService.notify(
          'success',
          'Product Updated',
          'Product has successfully been updated',
          'top',
          'right'
        );
        // Once all items have been updated, close the modal
        if (index + 1 === selectedRows.length) {
          this.bulkCategoryChangeToggle = !this.bulkCategoryChangeToggle;
        }
      });
    });
  }

  /****** EOF AG-GRID ******/

  onUpdateProductList(event) {
    // console.log('onUpdateProductList', event);
    this.getAllProducts();
  }

  showEditDialog(productId) {
    // console.log('show dialog in product list', productId);
    this.dialogProductId = productId;
    this.displayEditDialog = true;
  }

  onEditDialogClose(event) {
    // console.log('close dialog in product list', event);
    this.gridApi.deselectAll();
    this.dialogProductId = null;
    this.displayEditDialog = event;
  }

  public getAllProducts() {
    this.products = [];
    this._productsService
      .getAllProductsByStoreIdChunked(this.storeId)
      .subscribe((dataArray: any) => {
        dataArray.forEach((element) => {
          this.products = this.products.concat(element);
          // console.log(this.products);
        });
      });
  }

  public toggleCreateProductModal() {
    this.createProductModal = !this.createProductModal;
  }

  public categorySelected(event) {
    // console.log(event);
    this.createProductForm.patchValue({
      category: event.node,
    });
  }

  public kioskCategorySelected(event) {
    // console.log(event);
    this.createProductForm.patchValue({
      kioskCategory: event.node,
    });
  }

  public foodToGoCategorySelected(event) {
    // console.log(event);
    this.createProductForm.patchValue({
      foodToGoCategory: event.node,
    });
  }

  public onCreateProductFormSubmit() {
    const values = this.createProductForm.value;
    const body = {
      description: values.description,
      displayName: values.displayName,
      ean: values.ean,
      itemCategoryId: values.itemCategoryId,
      itemCategoryKioskId: values.itemCategoryKioskId,
      itemCategoryFoodToGoId: values.itemCategoryFoodToGoId,
      name: values.name,
      price: values.price,
      productCode: values.productCode,
      sortOrder: values.sortOrder,
      allergensApiProductId: values.sortOrder,
      storeId: this.storeId,
    };
    this._productsService.createProduct(body).subscribe((data: any) => {
      // console.log(data);
      this.createProductForm.reset();
      this.getAllProducts();
      this.toggleCreateProductModal();
      this.notificationService.notify(
        'success',
        'Product Created',
        'New Product has successfully been created',
        'top',
        'right'
      );
    });
  }

  // ************************************************************************* //
  // Functions to get, setup and handle Category Tree population and functions //
  // ************************************************************************* //

  public getAllCategories() {
    this.displayCategories = [];
    this._categoryService.getItemCategoriesByStoreId(this.storeId).subscribe((data: any) => {
      this.categories = data;
      this.filterRootItemCategories(null);
    });
  }

  public getAllKioskCategories() {
    this.displayKioskCategories = [];
    this._kioskCategoryService
      .getItemKioskCategoriesByStoreId(this.storeId)
      .subscribe((data: any) => {
        this.kioskCategories = data;
        this.filterRootItemKioskCategories(null);
      });
  }

  public getAllFoodToGoCategories() {
    this.displayFoodToGoCategories = [];
    this._foodToGoService.getItemCategoriesByStoreId(this.storeId).subscribe((data: any) => {
      this.foodToGoCategories = data;
      this.filterRootItemFoodToGoCategories(null);
    });
  }

  public populateTreeMenu(array) {
    const filteredArray = array;
    filteredArray.forEach((element) => {
      // console.log(element);
      const treeNodeObject = {
        label: element.name,
        data: element,
        id: element.id,
        parent: element.parentItemCategoryId,
        expandedIcon: 'fa fa-folder-open',
        collapsedIcon: 'fa fa-folder',
        leaf: false,
      };
      this.displayCategories.push(treeNodeObject);
    });
  }

  public populateKioskTreeMenu(array) {
    const filteredArray = array;
    filteredArray.forEach((element) => {
      const treeNodeObject = {
        label: element.name,
        data: element,
        id: element.id,
        parent: element.parentItemCategoryId,
        expandedIcon: 'fa fa-folder-open',
        collapsedIcon: 'fa fa-folder',
        leaf: false,
      };
      this.displayKioskCategories.push(treeNodeObject);
    });
  }

  public populateFoodToGoTreeMenu(array) {
    const filteredArray = array;
    filteredArray.forEach((element) => {
      const treeNodeObject = {
        label: element.name,
        data: element,
        id: element.id,
        parent: element.parentFoodToGoItemCategoryId,
        expandedIcon: 'fa fa-folder-open',
        collapsedIcon: 'fa fa-folder',
        leaf: false,
      };
      this.displayFoodToGoCategories.push(treeNodeObject);
    });
  }

  public filterRootItemCategories(categoryId) {
    const catId = categoryId;
    const filteredCats = this.objectFilter.transform(
      this.categories,
      'parentItemCategoryId',
      catId
    );
    this.populateTreeMenu(filteredCats);
  }

  public filterRootItemKioskCategories(kioskCategoryId) {
    const catId = kioskCategoryId;
    const filteredCats = this.objectFilter.transform(
      this.kioskCategories,
      'parentItemCategoryId',
      catId
    );
    this.populateKioskTreeMenu(filteredCats);
  }

  public filterRootItemFoodToGoCategories(foodToGoCategoryId) {
    const catId = foodToGoCategoryId;
    const filteredCats = this.objectFilter.transform(
      this.foodToGoCategories,
      'parentFoodToGoItemCategoryId',
      catId
    );
    this.populateFoodToGoTreeMenu(filteredCats);
  }

  public loadNode(event) {
    if (event.node) {
      const parentId = event.node.data.id;
      const children = this.objectFilter.transform(
        this.categories,
        'parentItemCategoryId',
        parentId
      );
      children.forEach((element) => {
        element.label = element.name;
        element.data = element;
        element.parent = element.parentItemCategoryId;
        element.expandedIcon = 'fa fa-folder-open';
        element.collapsedIcon = 'fa fa-folder';
        element.leaf = false;
      });
      event.node.children = children;
    }
  }

  public loadNodeKiosk(event) {
    if (event.node) {
      const parentId = event.node.data.id;
      const children = this.objectFilter.transform(
        this.kioskCategories,
        'parentItemCategoryId',
        parentId
      );
      children.forEach((element) => {
        element.label = element.name;
        element.data = element;
        element.parent = element.parentItemCategoryId;
        element.expandedIcon = 'fa fa-folder-open';
        element.collapsedIcon = 'fa fa-folder';
        element.leaf = false;
      });
      event.node.children = children;
    }
  }

  public loadNodeFoodToGo(event) {
    if (event.node) {
      const parentId = event.node.data.id;
      const children = this.objectFilter.transform(
        this.foodToGoCategories,
        'parentFoodToGoItemCategoryId',
        parentId
      );
      children.forEach((element) => {
        element.label = element.name;
        element.data = element;
        element.parent = element.parentFoodToGoItemCategoryId;
        element.expandedIcon = 'fa fa-folder-open';
        element.collapsedIcon = 'fa fa-folder';
        element.leaf = false;
      });
      event.node.children = children;
    }
  }

  public nodeSelect(event) {
    this.selectedCategory.label = event.node.data.name;
    this.selectedCategory.id = event.node.data.id;
    this.selectedCategory.data = event.node.data;
    this.createProductForm.patchValue({
      itemCategoryId: this.selectedCategory.id,
    });
  }

  public nodeSelectFoodToGo(event) {
    this.selectedFoodToGoCategory.label = event.node.data.name;
    this.selectedFoodToGoCategory.id = event.node.data.id;
    this.selectedFoodToGoCategory.data = event.node.data;
    this.createProductForm.patchValue({
      itemCategoryFoodToGoId: this.selectedFoodToGoCategory.id,
    });
  }

  public nodeSelectKiosk(event) {
    this.selectedKioskCategory.label = event.node.data.name;
    this.selectedKioskCategory.id = event.node.data.id;
    this.selectedKioskCategory.data = event.node.data;
    this.createProductForm.patchValue({
      itemCategoryKioskId: this.selectedKioskCategory.id,
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/products-v2/products-v2.component.ts